import { render, staticRenderFns } from "./RoleListTable.vue?vue&type=template&id=a1faad4a"
import script from "./RoleListTable.vue?vue&type=script&lang=js"
export * from "./RoleListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports